import React, { useEffect, useState } from "react";
import LocationForm from "Components/Location/LocationForm";
import { useParams } from "react-router-dom";
import { fetchLocationById } from "services/locationService";
import * as Sentry from "@sentry/react";

const LocationFormPage = () => {
  const { locationId } = useParams();
  const [location, setLocation] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadLocation = async () => {
      try {
        const data = await fetchLocationById(locationId);
        setLocation(data);
      } catch (error) {
        Sentry.captureException(error);
        console.error("Failed to load location:", error);
      } finally {
        setLoading(false);
      }
    };

    loadLocation();
  }, [locationId]);

  const handleSuccess = () => {
    window.location.href = `/locations/${locationId}`;
  };

  if (loading) return <div className="text-white text-center pt-20">Chargement...</div>;

  if (!location) return <div className="text-white text-center pt-20">Lieu introuvable.</div>;

  return (
    <div className="p-6 min-h-screen w-full bg-gray-700 pt-20">
      <LocationForm location={location} onSuccess={handleSuccess} />
    </div>
  );
};

export default LocationFormPage;
